import { render, staticRenderFns } from "./ProductAllotmentPage.vue?vue&type=template&id=7088080a&scoped=true"
import script from "./ProductAllotmentPage.vue?vue&type=script&lang=js"
export * from "./ProductAllotmentPage.vue?vue&type=script&lang=js"
import style0 from "./ProductAllotmentPage.vue?vue&type=style&index=0&id=7088080a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088080a",
  null
  
)

export default component.exports